<template>
  <van-popup  v-model="isShow" position="right" >
    <section class="filterPopup">
      <van-icon class="closeBtn" name="cross" @click="isShow = false"></van-icon>

      <!-- 品类 -->
      <div class="filterItem">
        <h3 class="f32">品类</h3>
        <ul>
          <li v-for="(data, dataIndex) in categoryLists"
              :key="dataIndex"

              @click="checkItem(data.id,1)" :class="categoryId == data.id ? 'active' : '' ">{{data.name}}</li>
        </ul>
        <h4 class="f28" @click="categotyMoreShow = true">更多品类<van-icon class="icon" name="arrow" /></h4>
      </div>

      <!-- 品牌 -->
      <div class="filterItem">
        <h3 class="f32">品牌</h3>
        <ul>
          <li v-for="(data, dataIndex) in brandLists"
              :key="dataIndex"
              :class="{'active':brandId === data.id}"
              @click="checkItem(data.id, 2)" >{{data.brandName}}</li>
        </ul>
        <h4 class="f28" @click="brandMoreShow = true">按首字母查询品牌<van-icon class="icon" name="arrow" /></h4>
      </div>

      <!-- 症状 -->
      <div class="filterItem" style='margin-bottom:100px'>
        <h3 class="f32">症状</h3>
        <ul>
          <li v-for="(data, dataIndex) in symptomLists"
              :key="dataIndex"
              :class="{'active':symptomId === data}"
              @click="checkItem(data, 3)">{{data}}</li>
        </ul>
        <!-- <h4 class="f28" @click="isShowSelectPopupObj[3] = true">更多症状<van-icon class="icon" name="arrow" /></h4> -->
      </div>


      <div class="g-fixed-bottom t_right">
        <button class="secondary" @click="reset">重置</button>
        <button class="primary" @click='submitSearch()'>确定</button>
      </div>
    </section>
    <!--品类弹窗-->
    <van-popup  v-model="categotyMoreShow" position="right" >
      <section class="categoryPopup">
        <van-icon class="closeBtn" name="cross" @click="categotyMoreShow = false"></van-icon>
        <div class="filterItem" v-for="(item, index) in categoryListMore" :key="index">
          <h3 class="f32">{{item.name}}</h3>
          <ul>
            <li v-for="(data, dataIndex) in item.categoryBoList"
                :key="dataIndex"
                :class="{'active':categoryId === data.id}"
                @click="checkItem(data.id,1,data)">{{data.name}}</li>
          </ul>
        </div>
      </section>
    </van-popup>
    <!--品牌弹窗-->
    <van-popup  v-model="brandMoreShow" position="right" >
      <section class="brandPopup">
        <van-icon class="closeBtn" name="cross" @click="brandMoreShow = false"></van-icon>
        <div class="filterItem" v-for="(item, index) in brandMore" :key="index">
          <h3 class="f32">{{item.title}}</h3>
          <ul>
            <li v-for="(data, dataIndex) in item.items"
                :key="dataIndex"
                :class="{'active':brandId === data.id}"
                @click="checkItem(data.id, 2, data)">
              <img :src="data.brandLogo" align="middle">
              <div class="f28 bold">{{data.brandName}}</div>
            </li>
          </ul>
        </div>
      </section>
    </van-popup>
    <!--症状弹窗-->
    <!-- <van-popup  v-model="isShowSelectPopupObj[3]" position="right" >
      <section class="symptomsPopup">
        <van-icon class="closeBtn" name="cross" @click="isShowSelectPopupObj[3] = false"></van-icon>
        isShowSymptomsPopup
      </section>
    </van-popup> -->
  </van-popup>
</template>

<script>
  import caseApi from "@/axios/case";
  export default {
    name: 'filterPopup',
    data () {
      return {
        isShow: false,
        categoryLists : [],
        brandLists : [],
        symptomLists : [],
        selectIdObj: {},
        //显示popup
        categotyMoreShow : false,
        brandMoreShow : false,
        // isShowCategoryPopup: false,
        categoryListMore: [] ,
        // isShowBrandPopup: false,
        brandMore: [],
        //选中的ID
        categoryId : '',
        brandId : '',
        symptomId : '',
      }
    },
    watch: {
      
    },
    computed: {},
    created () {
      this.getCatrgoryList();
      this.getcategoryTree();
      this.getBrandMore();
    },
    mounted () {
      this.reset()
    },
    methods: {
      formatImgUrl(url, width, height,m_fill) {
        // console.log(url)
        if (url) {
          url = url.replace('h_{height},w_{width}', "h_" + height + ",w_" + width + "");
          // url = url.replace(',jpg', ",webp");
          url +=',q_80';
          if(m_fill){
            // console.log(m_fill)
            url = url.replace('m_lfit', "m_fill");
          }
        }
        return url
      },
      submitSearch(){
        let params = {
          queryCategoryId : this.categoryId,
          queryBrandIdId : this.brandId,
          querySymptomName : this.symptomId
        }
        this.$emit('submitSearch',params);
        this.hide();
      },
      getBrandMore(){
        caseApi.getBrandMore({}).then((res)=>{

          this.brandMore = res.en;
          
        })
      },
      getcategoryTree(){
        caseApi.categoryTree({}).then((res)=>{

          this.categoryListMore = res;
          
        })
      },
      getCatrgoryList(){
        let params = {

        }
        caseApi.getCategory(params).then((res)=>{

          this.categoryLists = res;
          
        })
   
        caseApi.getBrand(params).then((res)=>{
          this.brandLists = res
        })

        caseApi.symptom(params).then((res)=>{
          this.symptomLists = res
        })
      },
      show () {
        this.isShow = true
      },
      hide () {
        this.isShow = false
      },
      // 显示次级弹窗
      showSecondPopup (id) {
        this.isShowSelectPopupObj[id] = true
      },
      checkItem (id,type,dataItem) {
        if(type == 1){
          this.categoryId = id;
          this.categotyMoreShow = false;
          if(dataItem){
            let tag = false;
            this.categoryLists.forEach((element)=>{
              if(element.id == id){
                tag = true;
              }
            })
            if(!tag){
              this.categoryLists.push(dataItem)
            }
          }
        }else if(type == 2){
          this.brandId = id;
          this.brandMoreShow = false;
          if(dataItem){
            let tag = false;
            this.brandLists.forEach((element)=>{
              if(element.id == id){
                tag = true;
              }
            })
            if(!tag){
              this.brandLists.push(dataItem);
            }
          }
        }else{
          this.symptomId = id;
        }
      },
      reset () {
        this.brandId = '';
        this.categoryId = '';
        this.symptomId = '';
      }
    }

  }
</script>

<style lang="scss" scoped>
  .mt100{
    margin-bottom: 100px;
  }
  .primary{
    position: absolute;
    right: 30px;
    top:9px;
  }
  .secondary{
    position: absolute;
    right: 270px;
    top:14px;
  }
  .popup{
    height: 100%;
    overflow: scroll;
  }
  .van-popup{
    &--right {
      width: 100%;
      height: 100%;
    }
    .filterPopup,.categoryPopup{
      padding: 40px 30px 0px;
      height: 100%;
      overflow: scroll;
      // margin-bottom: 50px;
      .filterItem{
        margin-bottom: 40px;
        h3{
          line-height: 44px;
          margin-bottom: 30px;
        }
        ul{
          display: flex;
          flex-wrap: wrap;
          margin-right: -20px;
          li{
            width: 176px;
            padding: 0 20px;
            height: 56px;
            line-height: 56px;
            background: #f6f6f6;
            font-size: 28px;
            margin:0 20px 20px 0;
            text-align: center;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
          }
          .active{
            background: $primary-color;
            color: $white-color;
          }
        }
        h4{
          line-height: 60px;
          color: $brand-color;
          .icon{
            vertical-align: middle;
          }
        }
      }
    }
    .closeBtn{
      position: absolute;
      right: 30px;
      top:45px;
      font-size: 32px;
    }
    .categoryPopup{
      padding: 40px 30px 0;
    }
    .brandPopup{
      padding: 40px 116px 0 30px;
      .filterItem{
        margin-bottom: 40px;
        h3{
          line-height: 44px;
          margin-bottom: 30px;
        }
        ul{
          li{
            padding: 8px 2px 12px;
            height: 66px;
            line-height: 66px;
            display: flex;
            border-bottom: $base-border;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
            img{
              width: 83px;
              height: 66px;
              margin-right: 24px;
            }
          }
          .active{
          }
        }
      }
    }
    .g-fixed-bottom button{
      margin-left: 20px;
    }
  }

</style>
